function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

function debounce(func, delay) {
  let timeoutID;

  return function () {
    const ctx = this;
    const args = arguments;

    clearTimeout(timeoutID);

    timeoutID = setTimeout(function () {
      func.apply(ctx, args);
    }, delay);
  };
}

/**
  * Return `pattern` with any special regex characters escaped.
  *
  * Ensures that `pattern` can be passed to `new RegExp(pattern)` without error
  * by escaping special characters.
  *
  * @example
  * // Returns "moo\\$e\\]"
  * escapeRegex("moo$e]");
  *
  * @param {String} pattern - The pattern to escape
  * @returns {String} A string suitable for use as an argument to `new RegExp()`
  */
function escapeRegex(pattern) {
  // Characters that are special in regular expressions and need escaping
  var special = "()[]{}<>.*+?:,^$";
  var escaped = "";
  var tok, strLen, idx;

  for (idx = 0, strLen = pattern.length; idx < strLen; idx++) {
    tok = pattern[idx];

    if (special.indexOf(tok) >= 0) escaped += "\\";
    escaped += tok;
  }

  return escaped;
}

function has(obj, key) {
  return obj !== null && Object.prototype.hasOwnProperty.call(obj, key);
}

module.exports = {
  clone,
  debounce,
  escapeRegex,
  has,
};
